import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-mara-bar-serapion',
  imports: [Link],
  templateUrl: './mara-bar-serapion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mara-bar-serapion.scss',
})
export class MaraBarSerapion {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Mara Bar Serapion`);
    this.dynamicTitle.description(`Mara Bar Serapion wrote to his son, in which he mentions a "wise king" who was executed by the Jews.`);
  }
}
